const debug = process.env.NODE_ENV !== 'production'

// import 'es6-promise/auto'
// console.log("--");
// if (window.localStorage) {
//   console.log(window.localStorage);
// }
// console.log("ok");

require("./bootstrap");
import Vue from "vue";
// Vue.config.productionTip = false;


/**
 * zepto
 */
import $ from 'zepto'
global.$ = $;
window.$ = $;



import _ from './common.js'
global._ = _;
window._ = _;
// console.dir(_);


/**
 * Buefy
 */
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
// import 'buefy/src/scss/buefy-build.scss'
Vue.use(Buefy, {
  defaultIconPack: 'fa',
})

// import Table from 'buefy/dist/components/table'
// import Input from 'buefy/dist/components/input'
// const buefy_setting = {
//   defaultIconPack: 'fa',
// };
// Vue.use(Table, buefy_setting)
// Vue.use(Input, buefy_setting)

/**
 * Mixin
 */
import {
  Mixin
} from './mixin'
Vue.mixin(Mixin)

/**
 * vue-scrollto
 */
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  duration: 700,
  easing: [0, 0, 0.1, 1],
  offset: -100
})

/**
 * vue-head
 */
import VueHead from 'vue-head'
Vue.use(VueHead, {
  separator: ' | '
})

/**
 * vue-analytics
 */
import VueAnalytics from 'vue-analytics'
if (!debug) {
  Vue.use(VueAnalytics, {
    id: 'UA-109163986-5',
    router
  })
}

import SocialSharing from 'vue-social-sharing';

Vue.use(SocialSharing);

/**
 * Filters
 */

//文字数制限
Vue.filter('truncate', function (value, length, omission) {
  var length = length ? parseInt(length, 10) : 20;
  var ommision = omission ? omission.toString() : '...';

  if (value.length <= length) {
    return value;
  } else {
    return value.substring(0, length) + ommision;
  }
});

//日付
import format from 'date-fns/format';
import ja from 'date-fns/locale/ja';
import parse from 'date-fns/parse';

Vue.filter('dateformat', (date = new Date(), formatStr) => {
  formatStr = formatStr ? formatStr : 'YYYY-MM-DD';
  // console.log(parse(date),formatStr);
  return format(parse(date), formatStr, {
    locale: ja
  })
});
// Vue.inject('date_format', (date = new Date(), formatStr) => {
//   return format(parse(date), formatStr, { locale: ja })
// });

import router from "./router";
import App from "./App.vue";
import store from "./store";
import * as types from "./store/mutation-types";

// import "./assets/css/styles.css";

// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue)
// import 'bootstrap/scss/bootstrap.scss'
// // import 'bootstrap-vue/dist/bootstrap-vue.min.css'

// font-awesome
// import "@fortawesome/fontawesome-free/scss/brands.scss";
// import "@fortawesome/fontawesome-free/scss/regular.scss";
// import "@fortawesome/fontawesome-free/scss/fontawesome.scss";

// import "./assets/scss/min.scss";
// import "./assets/scss/styles.scss";

new Vue({
  el: "#app",
  store: store,
  router: router,
  render: h => h(App),
  created() {
    // this.$store.commit(types.RESET_LOADING_PROGRESS);
    // this.$store.dispatch("getAllCategories");
    // this.$store.dispatch("getAllPages");
  }
});